import { all, } from "redux-saga/effects";
import { statusAppController } from "../modulos/root/root.controller"
import { medicoController } from "../modulos/medico/medico.controller"
import { salaController } from "../modulos/sala/sala.controller";
import { pacienteController } from "../modulos/paciente/paciente.controller";
import { atendimentoController } from "../modulos/atendimento/atendimento.controller";
import { configPainelChamadaController } from "../modulos/configPainelChamada/confpc.controller";
import { painelController } from "../modulos/painel/painel.controller";


export default function* rootSaga():any {
    return yield all([
        ...statusAppController.actionEffects,
        ...medicoController.actionEffects,
        ...salaController.actionEffects,
        ...pacienteController.actionEffects,
        ...atendimentoController.actionEffects,
        ...configPainelChamadaController.actionEffects,
        ...painelController.actionEffects
    ])
}
